module.exports = __webpack_public_path__ + "static/img/p5-1-3-hover.0139c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/p5-1-3-hover.png
// module id = O3Is
// module chunks = 1